/** @jsx jsx */
import { jsx } from '@emotion/core'
import style from './orderItemStyle';
import React from 'react';

import { Button, ErrorMessage } from '../../../components';
import utils from '../../../utils';

import { CartSummary } from '../cartSummary/summary';

export function OrderItems({ cart, form, moveNext, remove, currency }) {
  
  //const model = form.model;
  const items = form.findControl('items').controls;
  const render = (name, parent = null) => form.renderControl(name, parent);

  function itemAmount(item, orderItem) {
    const val = item.getValue();
    let unitPrice = orderItem.unitPrice;
    let currencyCode = "";
    if(currency === 'NZD' && (orderItem.productObject && orderItem.productObject.nzPrice)){
      unitPrice = orderItem.productObject.nzPrice;
      currencyCode = "NZD";
    }
    //utils.money.formatMoney(itemAmount(items[index], orderItem))
    const price = (val.quantity * (unitPrice * 100)) / 100;
    return currencyCode + utils.money.formatMoney(price);
  }

  const next = (e) => {
    form.validateForm(e, () => {
      moveNext();
    })
  }

  function ItemVariantSummary({ orderItem }) {
    if (!orderItem.variantOptionsSerialised) return null;
    const options = JSON.parse(orderItem.variantOptionsSerialised);
    return <div>{
      options
        .map(x => 
          <span>
            <span css={style.optionName}>{x.Name}:</span> 
            <span css={style.optionValue}>{x.Value}</span>
          </span>
        )
        .reduce((acc, x) => acc === null ? x : <React.Fragment>{acc}, {x}</React.Fragment>, null)
    }</div>
  }

  const orderItems = cart.orderItems.filter(x => x.orderItemType === 0);
  //const taxLines = cart.orderItems.filter(x => x.orderItemType === 1);

  return <div>
    <div className="row" >
      <div className="col-md-9">
        <form css={style.items}>
          {orderItems.map((orderItem, index) => <div key={orderItem.orderItemId} css={style.item}>

            <div className = "row">
              <div className = "col-sm-2">
                {
                  (orderItem.itemName === 'Kit Build' || orderItem.itemName === 'Kit Builder') ?
                  <KitBuildImage kitBuild = {orderItem.extSerialized}/> :
                  <img src={ orderItem.thumbnailUrl} alt = "immmm" />
                }
              </div>

              <div className = "col-sm-6">
                <b dangerouslySetInnerHTML={{ __html: orderItem.itemName }}></b>
                {
                  (orderItem.itemName === 'Kit Build' || orderItem.itemName === 'Kit Builder') &&
                  <KitBuildDetail kitBuild = {orderItem.extSerialized}/>
                }
                <ItemVariantSummary orderItem={orderItem} />
                <div css={style.orderItemError}>
                  {
                    (orderItem.productObject && orderItem.productObject.errorMsg && orderItem.productObject.errorMsg !== '') &&
                    orderItem.productObject.errorMsg
                  }
                </div>
              </div>

              <div className = "col-sm-2">
                Qty: {render('quantity', items[index])}
              </div>

              <div className = "col-sm-2" css={style.remove}>
                <b>{ itemAmount(items[index], orderItem)}</b>
                {/* <b>{ utils.money.formatMoney(itemAmount(items[index], orderItem))}</b> */}
                <Button btnStyle="outline-dark" className="btn-sm" onClick={(e) => remove(e, index)} status={form.status}>Remove</Button>
              </div>

            </div>

          </div>)}
          {/* {taxLines.map((orderItem, index) => <div key={orderItem.orderItemId} css={style.item}>
            <div css={style.product}>
              Tax: {orderItem.itemName}
            </div>
            <div css={style.details}>
              <div css={style.qty}>
               
              </div>
              <div css={style.amount}>
                <b>{utils.money.formatMoney(orderItem.unitPrice)}</b>
              </div>
              <div css={style.remove}>
                
              </div>
            </div>
          </div>)} */}
          
        </form>

      </div>
      <div className="col-md-3">
        <CartSummary cart={cart} currency = {currency} />
      </div>
      <div className="col-md-9 form__actions" style={{textAlign:'center'}}>
        <Button css={style.buttonStyle} className={`${(cart.orderItemNextCheckText && cart.orderItemNextCheckText === 'error') ? "inable" : "able"}`} onClick={next} status={form.status}>Next</Button>
        <ErrorMessage errors={form.errors} summaryMessage="Please review the errors." />
      </div>
    </div>
  </div>
}

function KitBuildImage(props){ 
  const kitBuildModel = props.kitBuild ? JSON.parse(props.kitBuild) : {};
  const _img = "data:image/png;base64, " + kitBuildModel.SingleItemCheckout.MainImage
  return(
    <img src={_img} alt="image2" />
  )
}

function KitBuildDetail(props){
  const kitBuildModel = props.kitBuild ? JSON.parse(props.kitBuild) : {};
  //console.log("kitBuildModel", kitBuildModel);
  return(
    <div>
      { kitBuildModel.SingleItemCheckout.Name }
    </div>
  )
}